<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId"
    [verifyRequiredValidator]="verifyRequiredValidator" [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="OK()" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy" [modalHelpIndex]="modalHelpIndex"
    [modalDraggable]=true [(isBusyMessage)]="isBusyMessage" [modalClass]="modalClass">
    <div class="modal-row buttonsRow" style="padding-bottom: 10px">
        <label for="file-upload" class="secondary-button">
            <i class="fa fa-folder-open loadFileIcon"></i> Load from File ...
        </label>
        <input id="file-upload" type="file" accept=".txt" (change)="newFileUploaded($event)" onclick="this.value=null;"
            data-automation-id="load-from-file-button" />
        <button type="button" data-automation-id="clear-all-button" class="secondary-button" (click)="clearAllEntries()"
            [disabled]="allEntries.length === 1" data-automation-id="clear-all-button">
            <i class="fa fa-trash fa-icon clearButtonIcon"></i>Clear All</button>
    </div>
    <div class="aliasesRow">
        <res-key-value-list [placeholderField1]='"Enter one per line or paste multiple ... "' [rows]="allEntries"
            [queryColumnHidden]="true" automationId="row-name-label-" [maxNameLength]="255"
            [validateName]="false"></res-key-value-list>
    </div>
</res-base-modal>